import React from 'react';

import * as ViewHooks from '../../../../state/views/hooks';
import {panelViews} from '../../../PanelBank/types';
import {MediaSettingsDrawerContent} from './MediaSettingsDrawerContent';
import {
  MediaSettingsDrawerContextProvider,
  useMediaSettingsDrawer,
} from './MediaSettingsDrawerContextProvider';
import {MediaSettingsDrawerPanelProps, SettingsLevel} from './types';

const MediaSettingsDrawerDataLoader = (
  props: MediaSettingsDrawerPanelProps
) => {
  const contextValue = useMediaSettingsDrawer(props);
  return (
    <MediaSettingsDrawerContextProvider contextValue={contextValue}>
      <MediaSettingsDrawerContent
        header={
          <h2 className="text-sm font-semibold leading-[22px] text-moon-500">
            PANEL SETTINGS
          </h2>
        }
        description="Customize settings for media in this panel."
        settingsLevel={SettingsLevel.PANEL}
      />
    </MediaSettingsDrawerContextProvider>
  );
};

export const MediaSettingsDrawer = ({
  panelRef,
  panelBankSectionConfigRef,
}: MediaSettingsDrawerPanelProps) => {
  const panel = ViewHooks.usePart(panelRef);
  if (panel.viewType !== panelViews.mediaBrowser) {
    return null;
  }
  return (
    <MediaSettingsDrawerDataLoader
      panelRef={panelRef}
      panelBankSectionConfigRef={panelBankSectionConfigRef}
    />
  );
};
